export const initStock = function () {
  const btnStock = document.querySelectorAll('[data-stock]');

  if (btnStock) {
    btnStock.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        item.classList.toggle('is-selected');
      })
    })
  }
}
